import { useContext, useMemo } from 'react';

import { LocalMallOutlined as LocalMallOutlinedIcon } from '@mui/icons-material';
import { track } from '../../../modules/segment/helpers';

import ReservationContext from '../../../providers/ReservationContext';

const useQuickActionsData = () => {
  const { orderV2Data } = useContext(ReservationContext);

  const value = useMemo(() => {
    if (!orderV2Data) return [];

    return [
      {
        Icon: LocalMallOutlinedIcon,
        label: 'Quick assistance',
        href: `/contact`,
        description: 'Call a specialist now.',
        linkText: 'Contact now',
        stepIDs: ['movePrep', 'moveDay', 'postMove'],
        displayOnMobile: false,
        onClick: () => track('Add Ons and Extras - Contact Now', { orderID: orderV2Data?.id }),
      },
    ].filter((item) => !!item);
  }, [orderV2Data]);

  return value;
};

export default useQuickActionsData;
